import axios from '../axios'

const EMPTY_OPTIONS = () => ({ productTypes: [], branches: [], projTypes: [] })

/**
 * Read-only access to the offline duplicate-enquiry analysis.
 *
 * Three endpoints, all GET:
 *   /v1/duplicateEnquiryPairs/{list}          the rows of one list (1, 2 or 3), filtered
 *   /v1/duplicateEnquiryPairs/counts          the row count of each list, filtered the same way
 *   /v1/duplicateEnquiryPairs/filterOptions   the values the Product Type / Branch /
 *                                             Project Type dropdowns offer
 *
 * The row endpoint returns a bare JSON array and puts the pre-paging match count in
 * the RecCount response header, which axios lower-cases to `reccount`.
 */
export default class DuplicateEnquiryService {
  /**
   * The query string. axios 0.20 writes an array as `key[]=a&key[]=b`, which Spring does
   * not bind to `key`, so each value of a multi-value filter goes as its own `key=...`.
   * The server reads them with getParameterValues, so a value with a comma in it stays
   * one value. Undefined and null are left out, as axios would leave them out.
   */
  static serializeParams(params) {
    const parts = []
    const add = (key, value) => {
      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(value)))
    }
    Object.keys(params || {}).forEach(key => {
      const value = params[key]
      if (value === undefined || value === null) {
        return
      }
      if (Array.isArray(value)) {
        value.forEach(v => add(key, v))
      } else {
        add(key, value)
      }
    })
    return parts.join('&')
  }

  getPairs(list, params) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/duplicateEnquiryPairs/' + list
        var response = await axios.get(path, {
          params: params || {},
          paramsSerializer: DuplicateEnquiryService.serializeParams
        })
        var rows = response.data || []
        var header = response.headers ? parseInt(response.headers.reccount) : NaN
        resolve({ rows: rows, recCount: isNaN(header) ? rows.length : header })
      } catch (err) {
        reject(err)
      }
    })
  }

  getCounts(params) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/duplicateEnquiryPairs/counts'
        var response = await axios.get(path, {
          params: params || {},
          paramsSerializer: DuplicateEnquiryService.serializeParams
        })
        resolve(response.data || {})
      } catch (err) {
        reject(err)
      }
    })
  }

  /** "Last refreshed" (05/10/2026): `{ date: 'dd/mm/yyyy' | null, source: 'run' | 'method' | null }`. */
  getLastRefreshed() {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.get('/v1/duplicateEnquiryPairs/lastRefreshed')
        resolve(response.data || {})
      } catch (err) {
        reject(err)
      }
    })
  }

  getFilterOptions() {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.get('/v1/duplicateEnquiryPairs/filterOptions')
        resolve(Object.assign(EMPTY_OPTIONS(), response.data || {}))
      } catch (err) {
        reject(err)
      }
    })
  }
}
